//v[Software.MayorRelease.MinorRelease.CorrectionRelease]
export const VERSION = "v1.6.2.3";
export const TKVERSION = "v1623";